<template>
    <div>
      <v-row>
        <v-col cols="12" xs="12" md="3">
          <v-autocomplete
            autocomplete="off"
            hide-details
            dense
            outlined
            v-model="FromStore"
            :items="stores"
            label="From Store"
            item-text="Name"
            item-value="id"
            filled
            readonly
          ></v-autocomplete>
        </v-col>
      </v-row>
  
      <v-row dense id="po" class="text--primary subtitle-2">
  
        <v-col cols="9" class="docForm">
          <v-data-table
            light
            :mobile-breakpoint="0"
            :items-per-page="pageItems"
            :headers="headers"
            :items="orderItems"
            item-key="id"
            hide-default-footer
            single-select
          >
            <template v-slot:item.edit="{ item }">
              <v-btn icon @click.native="openEditDialog(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
  
            <template v-slot:item.delete="{ item }">
              <v-btn color="red" icon @click.native="openDeleteDialog(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
  
      <v-row>
        <v-col cols="12" xs="12" md="3">
          <v-autocomplete
            autocomplete="off"
            hide-details
            dense
            outlined
            v-model="ToStore"
            :items="stores"
            label="To Store"
            item-text="Name"
            item-value="id"
            filled
            readonly
          ></v-autocomplete>
        </v-col>
  
        <v-col cols="12" xs="12" md="12">
          <v-btn color="accent" @click="save" :loading="loader"><v-icon left>mdi-content-save</v-icon>Create Transfer</v-btn>
        </v-col>
      </v-row>
  
  
      <!-- snackbar -->
      <snackbar ref="snackbar"></snackbar>
    </div>
  </template>
    
    
    <script>
  export default {
    props: {
      initial: {
        type: Object,
        required: true
      },
      payments: {
        type: Array
      },
      walkinCustomer: {
        type: Boolean
      },
      AccountsVersion: {
        type: String
      }
    },
    computed: {
      activeStore() {
        return localStorage.getItem("store_id");
      }
    },
    data: () => ({
      record: {},
      role: 3,
      copyObj: null,
      copyData: [{ Name: "Stock Transfer Delivery", id: 12 }],
      Account: null,
      FromStore: null,
      ToStore: null,
      PickedBy: null,
      search: null,
      editDialog: false,
      deleteDialog: false,
      deleteItem: {},
      dateDialog: false,
      Product: null,
      Quantity: null,
      Price: null,
      LineTotal: null,
      editItem: {},
      dialog: false,
      paymentDialog: false,
      customerDialog: false,
      CardCode: null,
      paymentItem: {},
      taxGroups: [],
      loader: false,
      pageItems: 100,
      selectedProduct: null,
      SumApplied: 0,
      DocNum: null,
      selectedItems: [],
      activeRow: null,
      storeId: null,
      singleSelect: true,
      orderItems: [],
      customers: [],
      accounts: [],
      products: [],
      isLoading: false,
      smsRef: null,
      select: "",
      searchingProduct: false,
      searchProducts: null,
      transferDialog: false,
      transferItem: {},
      userItem: {},
      inventory: [],
      stores: [],
      users: [],
      cancelledData: [],
      cancelOption: null,
      date: new Date().toISOString().substr(0, 10),
      CorrectDate: null,
      headers: [
        { text: "Item No", value: "ItemNo" },
        { text: "Item Code", value: "ItemCode" },
        { text: "Product", value: "Name" },
        { text: "Qty", value: "Quantity" }
      ],
      paymentHeaders: [
        { text: "Payment Mode", value: "o_a_c_t_s_id" },
        { text: "Amount", value: "SumApplied" }
      ]
    }),
    watch: {
      initial: {
        handler: "init",
        immediate: true
      }
    },
    methods: {
      init(val) {
        this.record = { ...val };
        this.FromStore = val.store_id;
        this.ToStore = val.ToStrCode;
        this.PickedBy = val.UserSign;
        const products = [];
        if (val.rows) {
          for (const row of val.rows) {
            row.Name = row.product.Name;
            row.ItemCode = row.product.ItemCode;
            row.productId = row.product.id;
            products.push(row);
          }
          this.orderItems = products;
        }
      },
      setDate(date) {
        this.CorrectDate = date;
      },
      getProducts() {
        const self = this;
        // const id = this.activeStore;
        this.$store
          .dispatch("get", `/products`)
          .then(res => {
            if (res.ResultCode == 1200) {
              self.products = res.ResponseData;
            } else {
              this.$refs.snackbar.show(res.msg, "red");
            }
          })
          .catch(err => {
            this.$refs.snackbar.show(err, "red");
          });
      },
      save() {
        var data = {};
        const url = `/copy-to-draft-inventory-transfers/${this.record.id}`;
        const self = this;
        self.loader = true;
        this.$store
          .dispatch("put", { url, data })
          .then(res => {
            if (res.ResultCode == 1200) {
              self.loader = false;
              self.$router.push("/transfer-drafts");
            } else {
              self.loader = false;
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .finally(() => {
            location.reload();
          })
          .catch(err => {
            self.loader = false;
            this.$refs.snackbar.show(err, "red");
          });
      },
      getCustomers() {
        const self = this;
        this.$store
          .dispatch("get", `/customers`)
          .then(res => {
            if (res.ResultCode == 1200) {
              const customers = res.ResponseData;
              customers.shift();
              self.customers = res.ResponseData;
            } else {
              this.$refs.snackbar.show(res.msg, "red");
            }
          })
          .catch(err => {
            this.$refs.snackbar.show(err, "red");
          });
      },
      getStores() {
        const self = this;
        this.$store
          .dispatch("get", `/all/stores`)
          .then(res => {
            if (res.ResultCode == 1200) {
              self.stores = res.ResponseData;
            } else {
              this.$refs.snackbar.show(res.msg, "red");
            }
          })
          .catch(err => {
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
    created() {
      Promise.all([this.getProducts(), this.getStores()]);
    }
  };
  </script>
    
    <style  scoped>
  /* .v-text-field__details {
      display: none !important;
    } */
  </style>